(function () {
    'use strict';

    angular.module("imApp").factory("travelWageSetService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1501,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 1502,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
